const regionSettings = require('@/' + process.env.VUE_APP_REGION + '.yml')
import {ORDER_TYPES} from 'nandos-middleware-api/model/food-basket'
import FoodBasketItem from 'nandos-middleware-api/model/food-basket-item'
import GiftCardBasketItem from 'nandos-middleware-api/model/gift-card-basket-item'
import UserProduct from 'nandos-middleware-api/model/user-product'
import {FirebaseAnalytics} from '@capacitor-firebase/analytics';


const CURRENCY = regionSettings.currency


export default class FirebaseAnalyticsTracker {

    constructor() {
        FirebaseAnalytics.setUserProperty({key: 'appVersion', value: process.env.VUE_APP_VERSION});
        FirebaseAnalytics.setUserProperty({key: 'property', value: process.env.VUE_APP_CONTEXT})
    }

    setUser(user) {
        let id = user.anonymous === true ? null : user.id
        FirebaseAnalytics.setUserId({userId: id});
    }

    setAttributionData(payload) {
        FirebaseAnalytics.logEvent({
            name: 'campaign_details',
            params: payload
        })

        try {
            FirebaseAnalytics.setUserProperty({key: "source", value: payload.source})
            FirebaseAnalytics.setUserProperty({key: "medium", value: payload.medium})
            FirebaseAnalytics.setUserProperty({key: "campaign", value: payload.campaign})
        } catch (e) {
            console.warn("failed to set user properties for firebase analytics")
        }

    }

    viewItemList(menuItem) {
        const eventData = {
            item_list_id: menuItem.id ?? "ROOT_MENU",
            item_list_name: menuItem.name ?? 'Root Menu',
            items: menuItem.children && menuItem.children.map((child) => ({
                item_id: child.id,
                item_name: child.name,
                item_category: child.trackingCategory,
                position: menuItem.children.indexOf(child),
            }))
        }
        if (['ANDROID', 'HUAWEI_ANDROID', 'IOS'].includes(process.env.VUE_APP_CONTEXT)) {
            delete eventData.items;
        }

        FirebaseAnalytics.logEvent({
            name: "view_item_list",
            params: eventData
        })
    }

    productImpressions(productImpressions) {
        // productImpressions.forEach(impression => {
        //     FirebaseAnalytics.logEvent({
        //         name: 'view_item',
        //         params: {
        //             item_id: impression.id,
        //             item_name: impression.name,
        //             item_category: impression.trackingCategory,
        //         },
        //     })
        // })
    }

    productClick(product, category) {
        FirebaseAnalytics.logEvent({
            name: 'select_item',
            params: {
                item_id: product.getId(),
                item_name: product.getName(),
                content_type: 'Product',
            },
        })
    }

    productView(product) {
        FirebaseAnalytics.logEvent({
            name: 'view_item',
            params: getTrackingDataFromItem(product),
        })
    }

    addToCart(products) { /* Products or GiftCards */
        Array.isArray(products)
            ? products.forEach(product =>
                FirebaseAnalytics.logEvent({name: 'add_to_cart', params: getTrackingDataFromItem(product),}))
            : FirebaseAnalytics.logEvent({name: 'add_to_cart', params: getTrackingDataFromItem(products),})
    }

    removeFromCart(basketItem) {
        FirebaseAnalytics.logEvent({name: 'remove_from_cart', params: getTrackingDataFromItem(basketItem),})
    }

    checkout(step, basket) {

        const params = {
            value: _toMoney(basket.totalPrice),
            currency: CURRENCY,
            items: basket ? basket.items.map((item) => ({
                item_id: item.id,
                item_name: item.productName,
                item_variant: item.computedDescription,
                item_price: _toMoney(item.productPrice),
                item_quantity: item.quantity,
                price: _toMoney(item.productPrice),
                quantity: item.quantity,
            })) : undefined
        }

        if (step === 1) {
            FirebaseAnalytics.logEvent({
                name: 'begin_checkout',
                params,
            })
        }
        if (step === 2) {
            FirebaseAnalytics.logEvent({
                name: 'add_shipping_info',
                params,
            })
        } else if (step === 3) {
            FirebaseAnalytics.logEvent({
                name: 'add_payment_info',
                params,
            })
        }
    }

    paymentOption(paymentSource, paymentAmount, isMultiPartPayment) {

        FirebaseAnalytics.logEvent({
            name: 'payment_type',
            params: {
                payment_type: isMultiPartPayment ? 'PARTIAL' : 'FULL',
            }
        })

        FirebaseAnalytics.logEvent({
            name: 'payment_option',
            params: {
                paymentOption: paymentSource,
                payment_option: paymentSource,
                optionRevenue: _toMoney(paymentAmount),
                paymentType: isMultiPartPayment ? 'PARTIAL' : 'FULL',
                payment_type: isMultiPartPayment ? 'PARTIAL' : 'FULL',
            },
        })
    }

    purchase(transactionId, basket, affiliation) {
        FirebaseAnalytics.logEvent({
            name: 'purchase',
            params: {
                transaction_id: transactionId,
                transactionId: transactionId,
                value: _toMoney(basket.totalPrice),
                shipping: basket.deliveryPrice ? _toMoney(basket.deliveryPrice) : "0.00",
                tax: _toMoney(basket.totalVat),
                currency: CURRENCY,
                location: affiliation,
                affiliation: affiliation,
                order_type: _getOrderTypeFromBasket(basket),
                items: basket ? basket.items.map((item) => ({
                    item_id: item.id,
                    item_name: item.productName,
                    price: _toMoney(item.productPrice),
                    item_variant: item.computedDescription,
                    item_quantity: item.quantity,
                    quantity: item.quantity,
                })) : undefined
            },
        })
    }

    addPaymentInfo() {
        // FirebaseAnalytics.logEvent({name: 'add_payment_info'})
    }

    search(path, queryParams) {
        const params = {
            search_term: queryParams['query'],
            search_ctx: queryParams['search-ctx'],
        }

        FirebaseAnalytics.logEvent({name: 'search', params,})
        FirebaseAnalytics.logEvent({name: 'view_search_results', params,})
    }

    pageView(path) {
        FirebaseAnalytics.setCurrentScreen({screenName: path,})
    }

    signUp(method) {
        FirebaseAnalytics.logEvent({name: 'sign_up', params: {method}})
    }

    login(method) {
        FirebaseAnalytics.logEvent({name: 'login', params: {method}})
    }
}

function _getOrderTypeFromBasket(basket) {
    switch (basket.orderType) {
        case ORDER_TYPES.DELIVERY:
            return 'delivery'
        case ORDER_TYPES.COLLECTION:
            return basket.kerbsideCollect ? 'kerbside' : 'collection'
        case ORDER_TYPES.EAT_IN:
            return 'eatIn'
    }
}

function _toMoney(val) {
    return parseFloat(val / 100)
}

function getTrackingDataFromItem(item, ...rest) {
    if (item instanceof UserProduct) {
        return _getTrackingDataFromProduct(item, ...rest)
    } else if (item instanceof FoodBasketItem) {
        return _getTrackingDataFromFoodBasketItem(item, ...rest)
    } else if (item instanceof GiftCardBasketItem) {
        return _getTrackingDataFromGiftCard(item, ...rest)
    } else {
        return item
    }
}

function _getTrackingDataFromProduct(product, overrideCategory) {
    return {
        item_id: product.getId(),
        item_name: product.getName(),
        item_category: overrideCategory || product.trackingCategory,
        price: _toMoney(product.computePrice()),
        value: _toMoney(product.computePrice() * product.orderQuantity),
        item_variant: product.getConfigurationDescription(),
        quantity: product.orderQuantity,
        currency: CURRENCY,
    }
}

function _getTrackingDataFromFoodBasketItem(item) {
    return {
        item_id: item.id,
        item_name: item.productName,
        item_category: 'basket/item',
        price: _toMoney(item.productPrice),
        value: _toMoney(item.productPrice * item.quantity),
        item_variant: item.computedDescription,
        quantity: item.quantity,
        currency: CURRENCY,
    }
}

function _getTrackingDataFromGiftCard(item) {
    return {
        item_id: `nandos-gift-card`,
        item_name: 'Gift Card',
        item_category: 'Gift Cards',
        price: _toMoney(item.price),
        value: _toMoney(item.price * item.cards.length),
        item_variant: `${money(item.price)}, design: ${item.srcImageUrl}`,
        quantity: item.cards.length,
        currency: CURRENCY,
    }
}